import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content',
    gap: theme.spacing(1),
    border: `1px solid ${theme.palette.warning.main}`,
    padding: theme.spacing(2),
    color: theme.palette.warning.main,
  },
  content: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
}));

export interface QuestionnaireBannerProps {
  onSubmit: () => void;
}

export function QuestionnaireBanner(props: QuestionnaireBannerProps) {
  const { root, content } = useStyles();
  const { onSubmit } = props;
  return (
    <section className={root}>
      <Typography variant="h6">Have you submitted your answers?</Typography>
      <div className={content}>
        <Typography variant="body2">
          Once you have completed all the questions and you are happy with your
          answers, please make sure you click on
        </Typography>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Submit
        </Button>
      </div>
    </section>
  );
}
